import {match} from 'ts-pattern';

import {mergeAll} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {workshopRoutes} from '@dms/routes';
import {DmsDataGrid, queryParams, workshopSearchParams} from '@dms/shared';

import {composePath, noop, useNavigate} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['serviceCaseId'] as const;

export function ServiceOrderOverview() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    rowId,
    getColumnData,
  }) => {
    const serviceCaseId = getColumnData<string>('serviceCaseId')?.value;

    const orderId = isArray(rowId) ? rowId[0] : rowId;
    const path = composePath(workshopRoutes.serviceCaseDetail, {
      params: {
        id: serviceCaseId,
      },
      queryParams: {
        source: 'service-orders',
        section: workshopSearchParams.serviceDetail.orders,
        [queryParams.SERVICE_CASE_ORDER_ID]: orderId,
      },
    });

    match(actionKey)
      .with('redirectDetail', () => navigate(path))
      .with('redirectDetail_newTab', () => window.open(path))
      .otherwise(noop);
  };

  const queryModifier = (filter: QueryFilterObject) => mergeAll([filter, {vehicleId: undefined}]);

  return (
    <DmsDataGrid
      data-testid="service-order-overview"
      gridCode="service-order"
      actionCallback={actionCallback}
      predefinedColumns={PREDEFINED_COLUMNS}
      queryModifier={queryModifier}
    />
  );
}
